import { IconsEnum } from "components/icon/Icon";
import Flex from "components/layout/Flex";

import { StyledIcon, StyledImage, StyledImageWithDiv, StyledName } from "./HeaderStyles";

interface IProps {
  name: string;
  imageUrl?: string;
  link?: string;
}

export const Header = (props: IProps): JSX.Element => (
  <Flex justifyContent="space-between" alignItems="center" width="100%">
    <Flex overflow="hidden">
      {props.imageUrl ? <StyledImage src={props.imageUrl} alt="header" /> : <StyledImageWithDiv />}
      <StyledName>{props.name}</StyledName>
    </Flex>
    {props.link && (
      <a href={props.link} rel="noopener noreferrer" target="_blank">
        <StyledIcon name={IconsEnum.ArrowRight} width="16px" height="16px" />
      </a>
    )}
  </Flex>
);
